export default __webpack_public_path__ + "static/media/4.60401706.svg";